module.exports = __webpack_public_path__ + "static/media/bryce-morris-resume.8b826de8.pdf";